"use client";

import Link from "next/link";

interface BlogHeroSectionProps {
  title?: string;
  subtitle?: string;
  showBreadcrumbs?: boolean;
}

export default function BlogHeroSection({
  title = "Blog",
  subtitle = "Expert insights on weight loss, health, and wellness",
  showBreadcrumbs = true,
}: BlogHeroSectionProps) {
  return (
    <section className="relative bg-gradient-to-br from-[#F6FAED] via-white to-[#FAEFFF] py-20 md:py-24 overflow-hidden">
      {/* Subtle decorative element */}
      <div className="absolute inset-0 opacity-[0.03]">
        <div className="absolute top-1/4 right-1/3 w-96 h-96 bg-[#7771B8] rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          {/* Main Title */}
          <h1 className="text-5xl sm:text-6xl md:text-7xl font-bold tracking-tight mb-4 bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 bg-clip-text text-transparent font-[family-name:var(--font-playfair)]">
            {title}
          </h1>

          {/* Breadcrumb Navigation */}
          {showBreadcrumbs && (
            <nav
              className="flex justify-center items-center mb-6"
              aria-label="Breadcrumb"
            >
              <ol className="flex items-center space-x-2 text-sm">
                <li className="flex items-center">
                  <Link
                    href="/"
                    className="text-gray-500 hover:text-[#7771B8] transition-colors duration-200 font-medium"
                  >
                    Home
                  </Link>
                </li>
                <li className="flex items-center">
                  <span
                    className="mx-2 text-gray-300 select-none"
                    aria-hidden="true"
                  >
                    /
                  </span>
                  <span className="text-gray-700 font-semibold">{title}</span>
                </li>
              </ol>
            </nav>
          )}

          {/* Subtitle */}
          {subtitle && (
            <p className="text-lg md:text-xl max-w-2xl mx-auto leading-relaxed text-gray-600">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
